import { render, staticRenderFns } from "./TextBetweenHeading3.vue?vue&type=template&id=2e3ba4f5&"
import script from "./TextBetweenHeading3.vue?vue&type=script&lang=js&"
export * from "./TextBetweenHeading3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports